import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'src/providers/ThemeProvider';
import styles from './TopBar.module.scss';
import Icon from '../Icon/Icon';

export interface TopBarProps {
  hideButton?: boolean;
  onClick?: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ hideButton, onClick }) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  return (
    <div className={styles.root}>
      <button
        className="cursor-pointer"
        type="button"
        onClick={() => navigate('/login')}
        aria-label="Navigate to login">
        <Icon
          className={styles.icon}
          name={theme === 'dark' ? 'logo-full-white' : 'logo-full-dark'}
          width={91}
          height={30}
        />
      </button>
      {!hideButton && onClick && (
        <button onClick={onClick} type="button" className="ml-auto flex gap-x-8">
          <Icon className="text-full opacity-40 rotate-180" name="arrowRight" width={20} height={20} />
          <span className="text-faded typo-text-14--medium">Go Back</span>
        </button>
      )}
    </div>
  );
};

export default TopBar;
